export default __webpack_public_path__ + "static/media/scholar_6.a2657448.jpg";